<template>
    <div class="templete_box">
        <div class="templete clearfix">
            <div class="companySetBox clearfix">
                <div class="companyTitle">公司名称:</div>
                <div class="companyContent">{{companyName}}</div>
            </div>
            <div class="companySetBox clearfix">
                <div class="companyTitle">税号:</div>
                <div class="companyContent">
                    <el-input class="companyInp" @change="update" v-model="companyMess.tax_no"/>
                </div>
            </div>
            <div class="companySetBox clearfix">
                <div class="companyTitle">开户行:</div>
                <div class="companyContent">
                    <el-input class="companyInp" @change="update" v-model="companyMess.bank_name"/>
                </div>
            </div>
            <div class="companySetBox clearfix">
                <div class="companyTitle">账户:</div>
                <div class="companyContent">
                    <el-input class="companyInp" @change="update" v-model="companyMess.bank_account"/>
                </div>
            </div>
            <div class="companySetBox clearfix">
                <div class="companyTitle">公司地址:</div>
                <div class="companyContent">
                    <el-input class="companyInp" @change="update" v-model="companyMess.address"/>
                </div>
            </div>
            <div class="companySetBox clearfix">
                <div class="companyTitle">联系电话:</div>
                <div class="companyContent">
                    <el-input class="companyInp" @change="update" v-model="companyMess.mobile"/>
                </div>
            </div>
            <div class="companySetBox companySetBoxLogo clearfix">
                <div class="companyTitle">公司Logo:</div>
                <div class="companyContent uploadImg">
                    <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                        <img v-if="companyMess.picture" :src="companyMess.picture" class="uploadImage"/>
                        <img v-if="!companyMess.picture" src="/icon/plus-default@2x.png" class="uploadImageAdd"/>
                    </el-upload>
                    <div v-if="companyMess.picture" class="deleteIcon" @click.stop="deleteLogo"><i class="el-icon-close"></i></div>
                </div>
            </div>
            <div class="companySetBox companySetBoxLogo clearfix">
                <div class="companyTitle">微信二维码:</div>
                <div class="companyContent uploadImg">
                    <el-upload class="upload-demo" ref='upload_path_qrcode' drag :action="oss.host" :data="upload_data"
                        :on-success="handleQrcodeSuccess" :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                        <img v-if="companyMess.qr_code" :src="companyMess.qr_code" class="uploadImage" />
                        <img v-if="!companyMess.qr_code" src="/icon/plus-default@2x.png" class="uploadImageAdd" />
                    </el-upload>
                    <div v-if="companyMess.qr_code" class="deleteIcon" @click.stop="deleteQrcode"><i class="el-icon-close"></i></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                companyName:localStorage.dw_erp_company_name,
                upload_data : {},
				oss : {
                    host : "",
                },
                file_url : '',
                companyMess:{
                    qr_code:"",
                    picture:"",
                    address:"",
                    mobile:"",
                    tax_no:"",
                    bank_name:"",
                    bank_account:""
                }
            }
        },
        created(){
            this.getList()
        },
        methods:{
            getList(){
                this.postFunc("/erp/company.info",{},res=>{
                    this.companyMess = res.data.data
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            update(){
                this.postFunc("/erp/company.update",this.companyMess,()=>{
                    this.tip('修改成功', 'success');
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            handleSuccess(res) {
                this.companyMess.picture = res.data.base_url;
                this.$refs.upload_path.clearFiles();
                // this.tip('文件上传成功', 'success');
                //this.importFile();
                this.update();
            },
            deleteLogo(){
                this.companyMess.picture = "";
                this.update();
            },
            handleQrcodeSuccess(res){
                this.companyMess.qr_code = res.data.base_url;
                this.$refs.upload_path_qrcode.clearFiles();
                this.update();
            },
            deleteQrcode(){
                this.companyMess.qr_code = "";
                this.update();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            importFile(){
                this.analysis('/erp/import.analysis',this.file_url,this.info.tpl_code,this.info.purchase_id,"",response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                        this.getDetailList()
                        this.importDialogVisible=false;
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        watch:{

        }
    }
</script>
<style scoped lang="scss">
    .companySetBox{margin-bottom:10px;}
    .companyTitle{font-size: 14px;float: left;margin-right:10px;height:30px;line-height: 30px;width:60px;}
    .companyContent{float: left;font-size: 14px;height:30px;line-height: 30px;}
    .companyInp{width:200px;}
    .companySetBoxLogo{height:110px;}
    .upload-demo{width:100px;height:100px;}
    .uploadImage{width:100px;height:100px;}
    .uploadImageAdd{width:35px;height: 35px;margin:auto;margin-top:32.5px;}
    .uploadImg{height: 102px;width: 102px;position: relative;}
    .uploadImg:hover .deleteIcon{display: flex;}
    .deleteIcon{position: absolute;right: 0;top: 0;z-index: 10;width: 102px;height: 102px;background: #B21111;opacity: 0.7; display: none;align-items: center;justify-content: center;border-radius: 6px;color: #fff;cursor: pointer;}
    .deleteIcon>i{display: flex;align-items: center;justify-content: center;width: 25px;height: 25px;border-radius: 50%;background: #fff;color: #B21111;font-size: 14px;}
</style>
